<template>
  <div>

    <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">首页</div>

    <div style="background-color: #eee;overflow-y: scroll;" :style="th">

      <div style="padding: 10px">

        <div>
          <div style="float: left;width:20%;">
            <div style="background-color: #fff;margin: 0px 5px;height: 80px;text-align: center;">
<!--              <a style="padding-top: 20px;display: block;">志愿队伍<br/>{{this.volunteerTeamCount}}</a>-->
              <el-link type="primary" href="/#/VolunteerTeam/CommandCenterPage" style="padding-top: 20px;color:black;">
                志愿队伍<br/>{{this.volunteerTeamCount}}
              </el-link>
            </div>
          </div>
          <div style="float: left;width:20%;">
            <div style="background-color: #fff;margin: 0px 5px;height: 80px;text-align: center;">

<!--              <div style="line-height: 40px;">志愿者</div>-->
<!--              <div style="">{{this.volunteerCount}}</div>-->
              <el-link type="primary" href="#" style="padding-top: 20px;color:black;">
                志愿者<br/>{{this.volunteerCount}}
              </el-link>
            </div>
          </div>
          <div style="float: left;width:20%;">
            <div style="background-color: #fff;margin: 0px 5px;height: 80px;text-align: center;">
<!--              <div style="line-height: 40px;">实践站点</div>-->
<!--              <div style="">{{this.practiceSiteCount}}</div>-->
              <el-link type="primary" href="/#/PracticeSite/CommandCenterPage" style="padding-top: 20px;color:black;">
                实践站点<br/>{{this.practiceSiteCount}}
              </el-link>
            </div>
          </div>
          <div style="float: left;width:20%;">
            <div style="background-color: #fff;margin: 0px 5px;height: 80px;text-align: center;">
<!--              <div style="line-height: 40px;">活动分类</div>-->
<!--              <div style="">{{this.activityClassCount}}</div>-->
              <el-link type="primary" href="/#/ActivityClass/CommandCenterPage" style="padding-top: 20px;color:black;">
                活动分类<br/>{{this.activityClassCount}}
              </el-link>
            </div>
          </div>
          <div style="float: left;width:20%;">
            <div style="background-color: #fff;margin: 0px 5px;height: 80px;text-align: center;">
<!--              <div style="line-height: 40px;">活动菜单</div>-->
<!--              <div style="">{{this.activityContentCount}}</div>-->
              <el-link type="primary" href="/#/ActivityContent/CommandCenterPage" style="padding-top: 20px;color:black;">
                活动菜单<br/>{{this.activityContentCount}}
              </el-link>
            </div>
          </div>

          <div style="clear: both;"></div>
        </div>

        <div style="height: 10px;"></div>

        <div>
          <div style="float: left;width:50%;">
            <div style="background-color: #fff;margin: 0px 5px;height: 80px;text-align: center;">
<!--              <div style="line-height: 40px;">本月累计活动</div>-->
<!--              <div style="">{{this.listMonthCount}}</div>-->
              <el-link type="primary" href="#" style="padding-top: 20px;color:black;">
                本月累计活动<br/>{{this.listMonthCount}}
              </el-link>
            </div>
          </div>
          <div style="float: left;width:50%;">
            <div style="background-color: #fff;margin: 0px 5px;height: 80px;text-align: center;">
<!--              <div style="line-height: 40px;">本年累计活动</div>-->
<!--              <div style="">{{this.listYearCount}}</div>-->
              <el-link type="primary" href="#" style="padding-top: 20px;color:black;">
                本年累计活动<br/>{{this.listYearCount}}
              </el-link>
            </div>
          </div>
          <div style="clear: both;"></div>
        </div>


        <div style="height: 10px;"></div>

        <div>
          <div style="float: left;width:50%;">
            <div style="background-color: #fff;margin: 0px 5px;">
              <div style="width: 100%;overflow: hidden;">
                <div style="text-align: center;padding: 20px">本月开展活动</div>
                <ve-line :data="chartData_total_day" :settings="chartSettings_total_day"></ve-line>
              </div>

            </div>
          </div>
          <div style="float: left;width:50%;">
            <div style="background-color: #fff;margin: 0px 5px;">
              <div style="width: 100%;overflow: hidden;">
                <div style="text-align: center;padding: 20px">本年开展活动</div>
                <ve-histogram :data="chartData_total_month" :settings="chartSettings_total_month"></ve-histogram>
              </div>

            </div>
          </div>
          <div style="clear: both;"></div>
        </div>

        <div style="height: 10px;"></div>

        <div>
          <div style="float: left;width:50%;">
            <div style="background-color: #fff;margin: 0px 5px;">
              <div style="width: 100%;overflow: hidden;">
                <div style="text-align: center;padding: 20px">月度服务类型占比</div>
                <ve-pie :data="chartData_class_month" :settings="chartSettings_class"></ve-pie>
              </div>
            </div>
          </div>
          <div style="float: left;width:50%;">
            <div style="background-color: #fff;margin: 0px 5px;">
              <div style="width: 100%;overflow: hidden;">
                <div style="text-align: center;padding: 20px">年度服务类型占比</div>
                <ve-pie :data="chartData_class_year" :settings="chartSettings_class"></ve-pie>
              </div>

            </div>
          </div>
          <div style="clear: both;"></div>
        </div>


      </div>

    </div>


  </div>

</template>



<script>


import {timeStr} from "@/common/times";
import {getStaffCode} from "@/utils/auth";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: "Home",

  components:{

  },
  data: function () {
    return {

      th:'',


      chartSettings_total_day:{
        labelMap:{
          day:"日期",
          count:"活动数",
          volunteerCount:"参与人数",
        }
      },
      chartData_total_day: {
        columns: ['day', 'count','volunteerCount'],
        rows: [
          {'day':'1','count':'20','volunteerCount':'200'},
        ]
      },




      chartSettings_total_month:{
        labelMap:{
          month:"月份",
          count:"活动数",
          volunteerCount:"参与人数",
        }
      },
      chartData_total_month: {
        columns: ['month', 'count','volunteerCount'],
        rows: [
          {'month':'1','count':'203','volunteerCount':'2000'},
        ]
      },




      chartSettings_elderly:{
        //设置中文图例
        labelMap:{
          //date对应后台返回json数据的key，具体值根据接口字段来修改
          age:"年龄",
          //total对应后台返回son数据的value，具体值根据接口字段来修改
          man:"男",
          woman:'女',
        }
      },
      chartData_elderly: {
        //这里的格式必须是对应上面后台接口的字段才能显示图例
        columns: ['age', 'man','woman'],
        rows: [
          {'age':'60-65','man':'20','woman':'22'},
          {'age':'66-70','man':'14','woman':'17'},
          {'age':'71-75','man':'10','woman':'12'},
          {'age':'76-80','man':'8','woman':'7'},
          {'age':'81-120','man':'7','woman':'4'},
        ]
      },

      chartSettings_class:{
        //设置中文图例
        labelMap:{
          //date对应后台返回json数据的key，具体值根据接口字段来修改
          class:"项目分类",
          //total对应后台返回son数据的value，具体值根据接口字段来修改
          total:"销售占比"
        }
      },
      chartData_class_month: {
        //这里的格式必须是对应上面后台接口的字段才能显示图例
        columns: ['class', 'total'],
        rows: [
          {'class':'理论宣讲','total':'203'},
          {'class':'科普宣传','total':'143'},
          {'class':'医疗建身','total':'93'},
          {'class':'法律服务','total':'60'},
          {'class':'卫生环保','total':'35'},
          {'class':'乡村振兴','total':'22'},
        ]
      },
      chartData_class_year: {
        //这里的格式必须是对应上面后台接口的字段才能显示图例
        columns: ['class', 'total'],
        rows: [
          {'class':'理论宣讲','total':'203'},
          {'class':'科普宣传','total':'143'},
          {'class':'医疗建身','total':'93'},
          {'class':'法律服务','total':'60'},
          {'class':'卫生环保','total':'35'},
          {'class':'乡村振兴','total':'22'},
        ]
      },



      volunteerTeamCount:0,
      volunteerCount:0,
      practiceSiteCount:0,
      activityClassCount:0,
      activityContentCount:0,

      listMonthCount:0,
      listYearCount:0,


    }
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = "height:"+(val+140-25)+"px";
    },
  },
  created(){
    this.th = "height:"+(this.$store.state.tableHeight+140-25)+"px";

    this.getVolunteerTeamCount();

    this.getPracticeSiteCount();

    this.getActivityClassCount();

    this.getActivityContentCount();

    this.getAlarmActivityOrderCount();


  },
  methods:{

    getVolunteerTeamCount(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"VolunteerTeam/PannelCmdCenter",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode:getStaffCode(),
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {

              this.volunteerTeamCount = response.data.data.volunteerTeamCount;
              this.volunteerCount = response.data.data.volunteerCount;

            }else if(response.data.error == 1){
              this.$message.error(response.data.message)
            }
          }
      )

    },

    getPracticeSiteCount(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"PracticeSite/PannelCmdCenter",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode:getStaffCode(),
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {

              this.practiceSiteCount = response.data.data.practiceSiteCount;

            }else if(response.data.error == 1){
              this.$message.error(response.data.message)
            }
          }
      )

    },

    getActivityClassCount(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"ActivityClass/PannelCmdCenter",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode:getStaffCode(),
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {

              this.activityClassCount = response.data.data.activityClassCount;


            }else if(response.data.error == 1){
              this.$message.error(response.data.message)
            }
          }
      )

    },

    getActivityContentCount(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"ActivityContent/PannelCmdCenter",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode:getStaffCode(),
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {

              this.activityContentCount = response.data.data.activityContentCount;


            }else if(response.data.error == 1){
              this.$message.error(response.data.message)
            }
          }
      )

    },

    getAlarmActivityOrderCount(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"ActivityOrder/PannelCmdCenter",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode:getStaffCode(),
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {

              this.listMonthCount = response.data.data.listMonthCount;
              this.listYearCount = response.data.data.listYearCount;

              this.chartData_total_day.rows = response.data.data.jsonArrayDay;
              this.chartData_total_month.rows = response.data.data.jsonArrayMonth;

              this.chartData_class_month.rows = response.data.data.jsonArrayMonthClass;
              this.chartData_class_year.rows = response.data.data.jsonArrayYearClass;

            }else if(response.data.error == 1){
              this.$message.error(response.data.message)
            }
          }
      )

    },



  }

}


</script>

<style>
a {
  text-decoraction: none;
}
.router-link-active {
  text-decoration: none;
}
</style>
